import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseCardComponent } from '../../atoms/cards/base-card/base-card.component';
import { BaseCardIconComponent } from '../../atoms/cards/base-card/base-card-icon.component';

@Component({
  selector: 'ui-info-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseCardComponent, BaseCardIconComponent],
  template: `
    <ui-base-card [class]="class()">
      <ui-base-card-icon icon [icon]="icon()" [iconClasses]="iconClasses()" />
      <ng-container content>
        <h3>{{ title() }}</h3>
        <ng-content></ng-content>
      </ng-container>
    </ui-base-card>
  `,
})
export class InfoCardComponent {
  icon = input<string>();
  title = input<string>();
  class = input<string>();
  iconClasses = input<string>();
}
